import { Dashboard } from '@/features/dashboard';

export const SuperAdminDashboard = Dashboard;

export * from './CreateSchool';
export * from './ListSchools';
export * from './SchoolDetails';
export * from './ListContacts';


